import {
  BlockEditor,
  ErrHandler,
  PageSelection,
  SalesBlockDefinition,
  PageStateProps,
} from '@course/components/page-builder';
import { SalespageContent } from 'server/types';
import { Dispatch, StateUpdater } from 'preact/hooks';

type BlockListProps = {
  content: SalespageContent;
  selectedId: string;
  undoRedoCount: number;
  selection: PageSelection;
  blockDefinitions: Record<string, SalesBlockDefinition>;
  onDeleteBlock: (id: string) => void;
  onMoveBlock: (id: string, direction: number) => void;
  onCloneBlock: (id: string) => void;
  onSelectBlock: (id: string) => void;
  onSetContent: Dispatch<StateUpdater<SalespageContent>>;
  onSetSelection: (selection: PageSelection) => void;
  onAddBlock: (blockId?: string) => void;
} & PageStateProps;

export function BlockList({
  content,
  selectedId,
  undoRedoCount,
  selection,
  blockDefinitions,
  onDeleteBlock,
  onMoveBlock,
  onCloneBlock,
  onSelectBlock,
  onSetContent,
  onSetSelection,
  onAddBlock,
  pageState,
  setPageState,
}: BlockListProps) {
  return (
    <>
      {content.blockIds.map((id, i) => {
        const blockState = content.blocks[id];
        const definition = blockDefinitions[blockState.type];
        return (
          <ErrHandler key={id} onRemove={() => onDeleteBlock(id)}>
            <BlockEditor
              id={id}
              version={undoRedoCount}
              definition={definition}
              definitions={blockDefinitions}
              selection={selection}
              onMove={onMoveBlock}
              onClone={onCloneBlock}
              position={i}
              isSelected={id === selectedId}
              onAddBlock={() => onAddBlock(id)}
              onDelete={onDeleteBlock}
              onSelect={() => onSelectBlock(id)}
              setState={onSetContent}
              setSelection={onSetSelection}
              state={blockState}
              pageState={pageState}
              setPageState={setPageState}
            />
          </ErrHandler>
        );
      })}
    </>
  );
}
